import apiCLient from '@shared/apiClient'

const SERVICE_PATH = 'user-content/alerts'

export const getApiClient = () => apiCLient.partneringOnePlus(SERVICE_PATH)
